import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import i18n from "i18next";
import { firebaseConnect } from 'react-redux-firebase';
import { withTranslation } from "react-i18next";
import * as actionsAccountModal from '../../actions/accountModalActions';
import CaProfileHeroView from "./CaProfileHeroView";


class CaProfileHeroContainer extends React.Component {

    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        const { openEditProfile } = this.props;
        openEditProfile();
    }

    render() {
        const { profile, backgroundImage, auth, score, maxPoints, tier } = this.props;
        if ((!profile || !auth) || (profile.isEmpty || auth.isEmpty)) {
            return (<div />);
        }

        let countryString = i18n.store.data.en.translations.country_list.filter((item) => (item.value.toLowerCase() == profile.country.toLowerCase()));
        if (countryString.length == 0) {
            countryString = "";
        } else if (countryString.length > 0) {
            countryString = countryString[0].label;
        }

        return (
            <CaProfileHeroView
                userName={profile.name + (!!profile.lastname ? (" " + profile.lastname) : "")}
                userEmail={auth.email}
                userCountry={countryString}
                backgroundImage={backgroundImage}
                scoreLabel={this.props.t('account_page.hero.score_caption')}
                score={score}
                tierLabel={this.props.t('account_page.hero.tier_caption')}
                tier={tier !== undefined ? tier.title : ""}
                maxPoints={maxPoints}
                cta={this.props.t('account_page.hero.edit_profile')}
                handleClick={this.handleClick}
            />
        )
    }
}

export default compose(
    connect((state) => ({
        auth: state.firebase.auth,
        profile: state.firebase.profile,
    }), Object.assign({}, actionsAccountModal)),
    firebaseConnect(),
)(withTranslation("translations")(CaProfileHeroContainer))





